module.exports = __webpack_public_path__ + "static/media/click-to-copy.c3df7d48.svg";